// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zF-z","hovered":"AF-z","hoverImage":"BF-z","mainImage":"CF-z","imageNoBackground":"DF-z","fullSizeImage":"EF-z"};